var portfolioPositionsTopFlop = {
	caption: {
		top: "Posiciones del portafolio con mejores resultados",
		flop: "Posiciones del portafolio con peores resultados",
		gainers: "Portfolio positions gainers",
		losers: "Portfolio positions losers"
	},
	name: "Nombre",
	isin: "ISIN",
	lastPrice: "Último Precio",
	lastPriceDateTime: "Fecha/Hora",
	unrealizedPerformance: "Unrealized perf. in {currency}",
	unrealizedPerformanceRelative: "Perdida / ganancia porcentual",
	unrealizedPerformanceBar: "Perdida / ganancia % of max",
	weight: "Peso %",
	marketValue: "Market value in {currency}",
	actions: "Acciones",
	noPositions: "Sin resultados"
};
var es = {
	portfolioPositionsTopFlop: portfolioPositionsTopFlop
};

export { es as default, portfolioPositionsTopFlop };
